import { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import "../styles/faq.scss";

const Faqea = (props) => {
    useEffect(() => {
        // 初始化手琴琴功能
        const accordions = document.querySelectorAll('.accordion-button');
        accordions.forEach(accordion => {
            accordion.addEventListener('click', function () {
                const target = this.getAttribute('data-bs-target');
                const collapse = document.querySelector(target);
                if (collapse.classList.contains('show')) {
                    collapse.classList.remove('show');
                } else {
                    collapse.classList.add('show');
                }
            });
        });
    }, []);
    return (
        <>
            <div className="accordion" id="accordionExample">
                            
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading7">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                                        Q：我沒有美國籍、綠卡、美國駕照，也可以考取 EA 嗎？
                                    </button>
                                </h2>
                                <div id="collapse7" className="accordion-collapse collapse show" aria-labelledby="heading7" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                    可以的！EA 的考試報名、執照申請，皆不要求美國籍、綠卡、或美國駕照。<br/>
                                    報考過程中，需申請一組 PTIN 號碼，申請手續容易、無上述身份的台灣人亦可申請；同時，Becker 團隊顧問提供完整解說、協助學員申請。
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading1">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                                        Q：EA 考試報名等規費，總共多少錢？
                                    </button>
                                </h2>
                                <div id="collapse1" className="accordion-collapse collapse" aria-labelledby="heading1" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                            A：<br/>
                                        <ul>
                                            <li>PTIN (Preparer Tax Identification Number) 申請費：US$31.00</li>
                                            <li>SEE (EA 考試名稱）考科費：單科 US$259.00，全科共 US$777.00</li>
                                            <li>考後執照申請費：$140.00<br />
                                            <br />
                                            以上加總，<strong>共 US$948.00 (約新台幣兩萬八）</strong>。<br />
                                            &nbsp;</li>
                                        </ul>

                                        <p><strong>取得 EA 執照後，每年需有以下維護執照效力的成本：</strong></p>

                                        <ul>
                                            <li>每 3 年進修 72 個 CE (Continue Education，稅務師進修教育時數)，平均每年進修 24 個：可單門購買網路課程、或使用訂閱制（<a href="https://beckertw.com/home/newdetail/621">了解更多</a>）</li>
                                            <li>每 3 年繳交一次續會費：US$19.00</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading2">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                                        Q：EA 什麼時候開放考試？
                                    </button>
                                </h2>
                                <div id="collapse2" className="accordion-collapse collapse" aria-labelledby="heading2" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                    EA 執照考試叫 SEE (Special Enrollment Examination)。SEE 可說是全時間開放，除了每年的 3 月到 4 月（此段期間進行年度試題更新）不開放考試。<br/>
                                    只要是授權可考 SEE 的 Prometric 測驗中心（例如全美境內的 Prometric），都可在上述期間內，任選考場營業日與時段、預約赴考。
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading3">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                                        Q：EA 規定多久要完成 SEE 考試呢?
                                    </button>
                                </h2>
                                <div id="collapse3" className="accordion-collapse collapse" aria-labelledby="heading3" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                    EA 執照考試叫 SEE (Special Enrollment Examination)、總共有三科考試，可任選順序應考，須於三年內通過三科（滾動式保留制度）。
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading4">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                                        Q：EA 考試裡，會考州稅嗎？
                                    </button>
                                </h2>
                                <div id="collapse4" className="accordion-collapse collapse" aria-labelledby="heading4" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                   EA 的資格證照考試（也就是 SEE 考試）範圍內不會考州稅，而是專注在聯邦稅法（Federal Tax Law）上，因 EA 資格讓你有權在美國全國性地代表納稅人處理 IRS 事務，與州稅政府機關無直接關係。<br/>
                                   雖然在某些情況下，聯邦稅法可能會間接涉及到一些與州稅相關的概念（例如：計算某些聯邦稅務時可能需要考慮州稅的扣除額），但考試的重點和深度都集中在聯邦稅務上，不涉及任何一州的特定稅法或規定。
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading5">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                                        Q：通過 SEE 考試之後，多久時間內必須申請 EA 執照？
                                    </button>
                                </h2>
                                <div id="collapse5" className="accordion-collapse collapse" aria-labelledby="heading5" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                    通過最後一科 SEE 考試日當天起算，你需要在一年內向 IRS 申請正式 EA 執照。
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="heading6">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                                        Q：取得 EA 執照後，如何參加執照進修 (CE) 課程？
                                    </button>
                                </h2>
                                <div id="collapse6" className="accordion-collapse collapse" aria-labelledby="heading6" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                    A：<br/>
                                    當您取得美國報稅師（Enrolled Agent, EA）執照後，為了維持執照的有效性，根據美國國稅局（IRS）的規定，每年必須完成進修教育（Continuing Education, CE）課程時數。<br/>
                                    EA 每年需完成至少 16 小時的 CE，其中必須包含 2 小時的道德課程（Ethics）。購買課程的方式通常為：<br/>
                                    <ul>
                                        <li>選擇 IRS 認可的 CE 課程提供平台（例如 Becker!）</li>
                                        <li>選購年費（訂閱制）方案，或按需求購買單門課程</li>
                                        <li>完成學習後，平台將自動回報學習時數給 IRS</li>
                                    </ul>
                                    Becker 提供的 CE 年費方案不僅涵蓋 EA 年度所需的課程時數，更包含稅法更新、道德課程與主題式課程。平台提供線上直播與隨選課程，<br/>
                                    學習進度可追蹤，並自動向 IRS 回報學習紀錄。若您希望使用一套系統性、全方位的進修方案，Becker 是許多 EA 的選擇之一。<br/>
                                    購課小撇步：<br/>
                                    <ul>
                                        <li>請確認平台為 IRS 認可教材供應商</li>
                                        <li>每年需完成：16 小時（含 2 小時道德）</li>
                                        <li>若三年內總時數達不到 72 小時，執照恐遭停權</li>
                                        <li>課程完成後務必確認系統已正確回報給 IRS</li>
                                    </ul>

                                    </div>
                                </div>
                            </div>
                        </div>
        </>
    );
};

export default Faqea;
